export default __webpack_public_path__ + "static/media/formrock-rockwool-komposition_comp.a809afd3.jpg";